import { useQuery } from '@tanstack/react-query'
import { getContactDetails } from './api'
import { BetAccountHolder } from '@mobi/api-types'
import { queryKeys } from '../ReactQuery/constants'

export const useContactDetails = (accountNumber: number | null) =>
  useQuery<BetAccountHolder>({
    queryKey: [queryKeys.accountContactDetails(accountNumber || 0)],
    queryFn: getContactDetails,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60, // 1hr
    enabled: !!accountNumber,
  })
